module.exports = __webpack_public_path__ + "find-folder.png?4cc50d1a04b9e645c5f6e8da323403aa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/find-folder.png
// module id = 929
// module chunks = 2